export class WebOrderStockDetailsDto {

    locationCode: number;
    locationName: string;
    productCode: number;
    productName: string;
    systemStockAllow: boolean;
    systemStock: number;
    manualStockAllow: boolean;
    manualStock: number;
}
